import React from "react"
import "./policy.scss"
import productPageImg from "../../../../assets/website-images/product/bio-page-banner.png";
import productBannerImg from "../../../../assets/website-images/product/product-banner.jpg";
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function PrivacyPolicy() {
    const {t} = useTranslation();
    return(
        <div className={'policy'}>
            <PageBanner img={productPageImg} heading={t('privacy_policy.banner_head')} bannerImg={productBannerImg}/>
            <div className={'section-3'}>

                <Container>
                    <Row>
                        <Col lg={12} xl={12}>
                            {/*<h3>{t('privacy_policy.main_head')}</h3>*/}
                            <p>{t('privacy_policy.para_1')}</p>
                            <h4>{t('privacy_policy.head_2')}</h4>
                            <p>{t('privacy_policy.para_2')}</p>
                            <p><b>{t('privacy_policy.head_2_sub_head_1')}</b> {t('privacy_policy.head_2_sub_para_1')}</p>
                            <p><b>{t('privacy_policy.head_2_sub_head_2')}</b> {t('privacy_policy.head_2_sub_para_2')}</p>

                            <h4>{t('privacy_policy.head_3')}</h4>
                            <p>{t('privacy_policy.para_3')}</p>
                            <p>{t('privacy_policy.para_3_sub')}</p>
                            <ul>
                                <li>{t('privacy_policy.list_1')}</li>
                                <li>{t('privacy_policy.list_2')}</li>
                                <li>{t('privacy_policy.list_3')}</li>
                                <li>{t('privacy_policy.list_4')}</li>
                            </ul>

                            <h4>{t('privacy_policy.head_4')}</h4>
                            <p>{t('privacy_policy.para_4')}</p>

                            <ul>
                                <li>{t('privacy_policy.list_5')}</li>
                                <li>{t('privacy_policy.list_6')}</li>
                                <li>{t('privacy_policy.list_7')}</li>
                                <li>{t('privacy_policy.list_8')}</li>
                            </ul>


                            <h4>{t('privacy_policy.head_5')}</h4>
                            <p>{t('privacy_policy.para_5')}</p>
                            <h4>{t('privacy_policy.head_6')}</h4>
                            <p>{t('privacy_policy.para_6')}</p>
                            <h4>{t('privacy_policy.head_7')}</h4>
                            <p>{t('privacy_policy.para_7')}</p>
                            <h4>{t('privacy_policy.head_8')}</h4>
                            <p>{t('privacy_policy.para_8')}</p>
                            <h4>{t('privacy_policy.head_9')}</h4>
                            <p>{t('privacy_policy.para_9')}</p>
                            <h4>{t('privacy_policy.head_10')}</h4>
                            <p>{t('privacy_policy.para_10')}</p>

                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}